import { render, staticRenderFns } from "./API.vue?vue&type=template&id=e122568e&scoped=true"
var script = {}
import style0 from "./API.vue?vue&type=style&index=0&id=e122568e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e122568e",
  null
  
)

export default component.exports